import type { ComponentType, SVGProps } from "react";
import { Box } from "lucide-react";
import Mechanical from "@/assets/svg/workspaces/mechanical.svg?react";
import Electronics from "@/assets/svg/workspaces/electronics.svg?react";
import Packaging from "@/assets/svg/workspaces/packaging.svg?react";
import FoodBeverage from "@/assets/svg/workspaces/food-beverage.svg?react";
import Bpch from "@/assets/svg/workspaces/bpch.svg?react";

const ICONS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  mechanical: Mechanical,
  electronics: Electronics,
  packaging: Packaging,
  fb: FoodBeverage,
  foodbeverage: FoodBeverage,
  foodandbeverage: FoodBeverage,
  bpch: Bpch,
};

function normalized(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}

/** The same tower glyph in the expanded tree and collapsed workspace header. */
export function WorkspaceIcon({
  workspaceId,
  label,
  size = 16,
}: {
  workspaceId: string;
  label: string;
  size?: number;
}): React.ReactElement {
  const name = [normalized(workspaceId), normalized(label)].find((value) => Object.hasOwn(ICONS, value));
  if (!name) return <Box size={size} aria-hidden data-workspace-icon="default" />;
  const Icon = ICONS[name];
  return <Icon width={size} height={size} aria-hidden focusable="false" data-workspace-icon={name} />;
}
